import {Mainmenu} from '../components/Mainmenu';

const mainMenuEl = document.querySelector('.menu_type_main');
const mainMenuParams = {
    accordionActiveClass: 'menu_active',
    accordionBodySelector: '.menu__nav',
    accordionBtnCloseSelector: '.menu__close',
    accordionTogglerSelector: '.burger',
    accordionTogglerActiveClass: 'open'
};

const headerPanel = document.querySelector('.header__col_type_panel');
const mainMenu = new Mainmenu(mainMenuEl, mainMenuParams, (data) => {
    const {isOpen} = data;
    if(isOpen){
        document.body.style.overflow = 'hidden';
        headerPanel.classList.add('header__col_hidden');
        document.querySelectorAll('.menu__footer').forEach(el => {
            el.classList.add('animate__fadeInDown');
        });
        document.querySelectorAll('.menu__animated').forEach(el => {
            el.classList.add('animate__fadeInUp');
        });
        document.querySelectorAll('.item_animate').forEach(el => {
            el.classList.add('animate__fadeInUp');
        });
        document.querySelectorAll('.tile-items__link').forEach(el => {
            el.classList.add('animate__flipInY');
        });
        document.querySelectorAll('.menu__navigate').forEach(el => {
            el.classList.remove('menu__navigate_active');
        });
    } else {
        document.body.style = null;
        headerPanel.classList.remove('header__col_hidden');
        document.querySelectorAll('.menu__footer').forEach(el => {
            el.classList.remove('animate__fadeInDown');
        });
        document.querySelectorAll('.menu__animated').forEach(el => {
            el.classList.remove('animate__fadeInUp');
        });
        document.querySelectorAll('.item_animate').forEach(el => {
            el.classList.remove('animate__fadeInUp');
        });
        document.querySelectorAll('.tile-items__link').forEach(el => {
            el.classList.remove('animate__flipInY');
        });
    };
});
mainMenu.setEventListeners();

export {mainMenuEl, mainMenuParams};


const companyItemssArr = Array.from(document.querySelectorAll('.company-advantage__item'));
const infoItemssArr = Array.from(document.querySelectorAll('.company-advantage-right'));

function advantagesToggler(item,arr,className){
    const targetElArr = arr.filter(el => el != item);
    for(let i = 0; i < targetElArr.length; i++) {
        targetElArr[i].classList.remove(className);
    }
    item.classList.add(className);
};
companyItemssArr.forEach((item,index,arr) => {
    item.addEventListener('click', (e) => {
        const targetElId = e.currentTarget.getAttribute('data-target');
        const targetEl = document.querySelector(targetElId);
        advantagesToggler(e.currentTarget,arr,'company-advantage_active'); 
        advantagesToggler(targetEl,infoItemssArr,'company-advantage-right_active'); 
  });
});


const buttonCompount = document.querySelector('.btn_compound');

if (buttonCompount) {
    buttonCompount.addEventListener('click',(e) =>{
        document.querySelector('.compound-man-4').classList.add('compound_active');
        document.querySelector('.compound-man-5').classList.add('compound_active');
    });
}

/*
const buttonCoupon = document.querySelector('.cart__coupon-icon-btn');
const buttonCouponError = document.querySelector('.cart__coupon-error');
if (buttonCoupon) {
    buttonCoupon.addEventListener('click', (e) => {
        buttonCouponError.classList.remove('cart__coupon-error_active');
    });
}
*/
 